import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Global On-Line Network Education",
  publicUrl: "https://ai-tutor.g-one-business-english.com",
  pwaServiceName: "G-ONe",
  appLogoPath: "/partner/g-one-business-english/logo.png",
  appLogoHeight: "25px",
  landingLogoPath: "/partner/g-one-business-english/logo.png",
  landingLogoHeight: "30px",
  hubLogoPath: "/partner/g-one-business-english/icon.png",
  hubLogoHeight: "40px",
  favicon: "/partner/g-one-business-english/icon.png",
  pwaIcons: [
    {
      src: "/partner/g-one-business-english/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "info@lang-services.com",
  adminEmail: "contact@g-one-inc.com",
  reviewLink: null,
  copyright: "G-ONe Communications, Inc.",
  showLanguageGuides: true,
  enableRecordingPlayback: true,
  bioPrompt: `
    You are a language tutor at G-One communications. We help learners from Japan improve their business English speaking skills through role-plays. Tutors engage students in practice conversations, playing the role of a client, customer, supervisor, or subordinate. Providing feedback on vocabulary, pronunciation, and appropriate register is most important to us.
  `,
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-primary-500)",
      speakInputRecording: "var(--chakra-colors-brand-primary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-primary-900)",
    },
  },
  colors: {
    light: {
      main: "#F0F8FF",
      alt: "#F0F8FF",
    },
    primary: {
      main: "#0000FF",
      mainContrast: "#fff",
      "50": "#f7f7ff",
      "100": "#ddddff",
      "200": "#c0c0ff",
      "300": "#9c9cff",
      "400": "#8787ff",
      "500": "#6969ff",
      "600": "#4e4eff",
      "700": "#2525ff",
      "800": "#0000f1",
      "900": "#0000b5",
    },
    secondary: {
      main: "#0000FF",
      mainContrast: "#fff",
      "50": "#f7f7ff",
      "100": "#ddddff",
      "200": "#c0c0ff",
      "300": "#9c9cff",
      "400": "#8787ff",
      "500": "#6969ff",
      "600": "#4e4eff",
      "700": "#2525ff",
      "800": "#0000f1",
      "900": "#0000b5",
    },
    tertiary: {
      main: "#0000FF",
      mainContrast: "#fff",
      "50": "#f7f7ff",
      "100": "#ddddff",
      "200": "#c0c0ff",
      "300": "#9c9cff",
      "400": "#8787ff",
      "500": "#6969ff",
      "600": "#4e4eff",
      "700": "#2525ff",
      "800": "#0000f1",
      "900": "#0000b5",
    },
    gray: {
      "50": "#fafafa",
      "100": "#f1f1f1",
      "200": "#e7e7e7",
      "300": "#d4d4d4",
      "400": "#adadad",
      "500": "#7f7f7f",
      "600": "#545454",
      "700": "#373737",
      "800": "#202020",
      "900": "#191919",
    },
    purple: {
      "50": "#f9f5ff",
      "100": "#e6d9ff",
      "200": "#d3bcff",
      "300": "#b692ff",
      "400": "#a273ff",
      "500": "#8547ff",
      "600": "#6a20ff",
      "700": "#4e00e9",
      "800": "#4100c2",
      "900": "#310094",
    },
    pink: {
      "50": "#fff5fa",
      "100": "#ffd6ea",
      "200": "#ffb3d9",
      "300": "#ff7fbf",
      "400": "#ff50a8",
      "500": "#ee0078",
      "600": "#cd0067",
      "700": "#a90055",
      "800": "#850043",
      "900": "#640032",
    },
    red: {
      "50": "#fff5f5",
      "100": "#ffd7d7",
      "200": "#ffb2b2",
      "300": "#ff7f7f",
      "400": "#ff5c5c",
      "500": "#fb0000",
      "600": "#d50000",
      "700": "#ae0000",
      "800": "#950000",
      "900": "#6e0000",
    },
    orange: {
      "50": "#fffaf4",
      "100": "#ffead4",
      "200": "#ffd0a1",
      "300": "#ffa952",
      "400": "#fd7f00",
      "500": "#da6e00",
      "600": "#b85d00",
      "700": "#934a00",
      "800": "#743a00",
      "900": "#5f3000",
    },
    yellow: {
      "50": "#fffef9",
      "100": "#fff9dd",
      "200": "#ffee96",
      "300": "#ffde36",
      "400": "#f0c900",
      "500": "#c6a500",
      "600": "#9e8400",
      "700": "#7b6700",
      "800": "#5d4d00",
      "900": "#4c4000",
    },
    green: {
      "50": "#effff7",
      "100": "#99ffcc",
      "200": "#00f57b",
      "300": "#00db6e",
      "400": "#00bf60",
      "500": "#00a553",
      "600": "#008844",
      "700": "#006a35",
      "800": "#00572c",
      "900": "#004824",
    },
    teal: {
      "50": "#e4ffff",
      "100": "#56ffff",
      "200": "#00ecec",
      "300": "#00d3d3",
      "400": "#00b3b3",
      "500": "#009999",
      "600": "#007c7c",
      "700": "#006161",
      "800": "#005151",
      "900": "#004242",
    },
    cyan: {
      "50": "#effcff",
      "100": "#b8f3ff",
      "200": "#94edff",
      "300": "#65e5ff",
      "400": "#00c5ed",
      "500": "#00b5d9",
      "600": "#00a3c4",
      "700": "#0087a2",
      "800": "#006f85",
      "900": "#005668",
    },
    blue: {
      "50": "#eff7ff",
      "100": "#c3e1ff",
      "200": "#96caff",
      "300": "#62b0ff",
      "400": "#2d95ff",
      "500": "#007cf8",
      "600": "#0068d0",
      "700": "#004fa0",
      "800": "#004183",
      "900": "#00356b",
    },
  },
};
